import React from "react";
import { Card } from "../BP2Components";
import { CardInterface } from "../BP2Components/Card/Card";

interface WidgetInterface extends CardInterface {
   bgColor?: string;
   role?: string;
   isFormBuilder?: boolean;
}

const Widget: React.FC<WidgetInterface> = ({
   title,
   children,
   cover,
   extra,
   actions,
   bgColor,
   className,
   onClick = undefined,
   role,
   overflow = "visible",
   hideCardHead = false,
}) => {
   const isHeaderShouldBeHidden = () => {
      return (
         hideCardHead || (role && role !== "OWNER" && role !== "MODERATOR") || (!title && !extra)
      );
   };

   return (
      <Card
         hideCardHead={isHeaderShouldBeHidden()}
         title={title}
         actions={actions}
         cover={cover}
         className={`gx-card-widget ${className}`}
         style={{ backgroundColor: bgColor }}
         extra={extra}
         onClick={onClick}
         cardType="widget"
         overflow={overflow}
      >
         {children}
      </Card>
   );
};

export default Widget;
